import videojs from 'video.js';

const registerPlugin = videojs.registerPlugin || videojs.plugin;

class FlockPlayLoader {
  static init(player, options) {
    let hls= player.hls_;

    hls.on('hlsMediaDetaching', () => {
      if (hls.config._flockplay && hls.config._flockplay.fill_buffer_timer) 
        clearInterval(hls.config._flockplay.fill_buffer_timer);
      hls.config._flockplay = null;
    });

    let old_fLoader = hls.config.fLoader;
    let first_error = false;
    let fLoaderError = function(err) {
      if (!first_error) {
        console.error(err);
        first_error = true;
      }
      return old_fLoader;
    };

    Object.defineProperty(hls.config, 'fLoader', {
      configurable: true, 
      get: () => {
        if (!window['MegacdnClient']) return fLoaderError('Flockplay library is not not found.');
        if (typeof WebSocket == 'undefined')
          return fLoaderError('Flockplay is not supported in this browser.');

        if (player.flockplay_disabled) return old_fLoader;

        if (typeof hls.config._flockplay == 'undefined') {
          if (player.flockplay_) {
            player.flockplay_.hls = hls;
            hls.config._flockplay = player.flockplay_;
          } else {
            hls.config._flockplay = null;
            FlockPlayLoader.initFlockplay(player, hls, options);
          }
        }
        return player.flockplay_ ? FlockPlayLoader : old_fLoader;
      }
    });
  }

  static initFlockplay(player, hls, options) {
    options.peer_bad_speed = 0;
    let flockplay = new window['MegacdnClient'](options, err => {
      if (err) return console.error(err);
      flockplay.hls = hls;
      player.flockplay_ = hls.config._flockplay = flockplay;
      
      // доп. статистика для flockplay-я
      flockplay.stat.buffer = 0;
      flockplay.stat.bad_buffers = 0;
      // флаги используемые ниже
      flockplay.fill_buffer = false;        // наполняем буфер
      flockplay.fill_buffer_enabled = true; // использовать логику наполнения буфера
      flockplay.zero_buffer_count = 0;      // счётчик нулевых буферов

      flockplay.global_stat = {
        zero_buffer_count: 0,               // накопленный счетчик нулевых буферов
        http_download_size: 0,              // накопленный счетчик полученных через http байт
        flockplay_download_size: 0,         // накопленный счетчик полученных через flockplay байт
        chunks: []                          // скаченные чанки
      };

      // таймер управлением логикой fill_buffer-а
      flockplay.fill_buffer_timer = setInterval(() => {
        FlockPlayLoader.fillBufferTimer(flockplay);
      }, 30000);
      if (options.disable_distribution) flockplay.disableDistribution();
    });
  }

  static fillBufferTimer(flockplay) {
    // если http слишком медленнен - выключаем логику наполнения буфера
    flockplay.fill_buffer_enabled = flockplay.stat.http_count <= flockplay.stat.peer_count || 
      flockplay.stat.http_bad_count / flockplay.stat.http_count < 0.5;
  }

  constructor(config) {
    this.flockplay = config._flockplay;
    this.hls = config._flockplay.hls;
    this.player_config = config;
    this.stats = {
      aborted: false,              // must be set to true once the request has been aborted
      loaded: 0,                   // nb of loaded bytes
      total: 0,                    // total nb of bytes
      retry: 0,                    // number of retries performed
      chunkCount: 0,               // number of chunk progress events
      bwEstimate: 0,               // download bandwidth in bits/s
      loading:   {start: 0, first: 0, end: 0},
      parsing:   {start: 0, end: 0},
      buffering: {start: 0, first: 0, end: 0}
    };
    if (this.flockplay.peer.closed || false) return new config.loader(config);
  }

  destroy() {
    this.callbacks = null;
    if (!this.stats?.loaded) this.abortInternal();
    this.context = null;
    this.config = null;
  }

  abortInternal() {
    if (!this.flockplay || !this.context) return;   
    
    if (!this.stats?.end) this.stats.aborted = true;

    this.stopHlsPluginDeception();
    this.flockplay.log('abortFile', this.context.url);
    this.flockplay.stopFile(this.context.url);
    this.flockplay = null;
  }

  abort() {
    this.abortInternal();
    if (this.callbacks?.onAbort) {
      this.callbacks.onAbort(
        this.stats,
        this.context,
        this.flockplay?.stat
      );
    }
  }

  load(context, config, callbacks) {
    //debugger;
    if (this.stats.loading.start) {
      throw new Error('Loader can only be used once.');
    }
    this.stats.loading.start = performance.now();
    
    this.context = context;
    this.config = config;
    this.callbacks = callbacks;
    this.flockplay.log('getFile', context.url, this.getCurrentBuffer(), context.frag.duration);
    
    this.performBufferLogic();
    this.startHlsPluginDeception();
    
    this.flockplay.log('peer_try_count = '+this.flockplay.peer_try_count);
    this.flockplay.getFile(context.url, (error, data, info) => {
      this.stopHlsPluginDeception();
      let arr_buf_result;
      if (error) {
        console.error('flockplay.getFile error, use default loader', error);
        let loader = new this.player_config.loader(this.player_config);
        loader.load(context, config, callbacks);
      } else {
        try {
          arr_buf_result = this.dataURItoArrayBuffer(data);
        } catch (buff_cnv_err) {
          console.error('flockplay.dataURItoArrayBuffer error, use default loader', buff_cnv_err);
          let loader = new this.player_config.loader(this.player_config);
          loader.load(context, config, callbacks);
          return;
        }
        
        let response = {url: this.context.url, data: arr_buf_result};
        this.setHlsPluginStats(info);
        // особенности hls.js - нельзя отдавать ответ синхронно (что возможно при отдаче из js кеша)
        setTimeout(() => {
          this.callbacks.onSuccess(response, this.stats, this.context);
        }, 0);
        this.addFLockplayStat(context.frag.duration, info);
      }
    });
  }

  performBufferLogic() {
    let current_buffer = this.getCurrentBuffer();
    let max_buffer = this.getMaxBuffer();

    if (current_buffer <= 0.1) {
      this.flockplay.zero_buffer_count += 1;
    } else {
      this.flockplay.zero_buffer_count = 0;
    }
    
    if (this.flockplay.fill_buffer_enabled && current_buffer > max_buffer * 0.6) {
      if (this.flockplay.fill_buffer) this.flockplay.log('****** Disable fill_buffer ******');
      this.flockplay.fill_buffer = false;
    }
    if (this.flockplay.fill_buffer_enabled && current_buffer < max_buffer * 0.2) {
      if (!this.flockplay.fill_buffer) this.flockplay.log('****** Enable fill_buffer ******');
      this.flockplay.fill_buffer = true;
    }
    
    let buffer_factor = this.flockplay.fill_buffer ? 
      this.flockplay.options.http_failback_fill_factor : 
      this.flockplay.options.http_failback_factor;
    this.flockplay.peer_timeout = Math.round(
      Math.max(current_buffer - this.context.frag.duration * buffer_factor, 0) * 1000
    );
    if (this.flockplay.fill_buffer) {
      this.flockplay.peer_try_count = 1;
    } else {
      // 1 попытка в среднем 500мс
      let max = this.flockplay.peer_timeout / 500;
      if (max < 5) max = 5;
      if (this.flockplay.channel) {
        this.flockplay.peer_try_count = max;
      } else {
        this.flockplay.peer_try_count = Math.floor(3 + Math.random() * (max-3));
      }
    }
    this.flockplay.peer_bad_time = this.context.frag.duration * 1000; // в мс
  }

  addFLockplayStat(frag_duration, info) {
    let current_buffer = this.getCurrentBuffer();
    if (current_buffer < 0 && this.flockplay.zero_buffer_count >= 2) {
      this.flockplay.stat.bad_buffers++;
      this.flockplay.global_stat.zero_buffer_count++;
    }
    this.flockplay.stat.buffer += Math.round(1000 * (current_buffer + frag_duration / 2)); // в мс
    if (info.type == 'http') {
      this.flockplay.global_stat.http_download_size += info.size;
    } else {
      this.flockplay.global_stat.flockplay_download_size += info.size;
    }
    this.flockplay.global_stat.chunks.push({
      url: info.response_url || info.url,
      type: info.type == 'http' ? 'http' : 'flockplay',
      size: info.size,
      duration: frag_duration,
      time: info.receive_time/1000,
      src_flockplay_peer_id: this.flockplay.channel && this.flockplay.channel.remoute_peer_id
    });    
  }

  startHlsPluginDeception() {
    this.hls_plugin_deception_timer = setInterval(() => {
      this.stats.loading.start = performance.now();
    }, 500);
  }

  stopHlsPluginDeception() {
    if (this.hls_plugin_deception_timer) {
      clearInterval(this.hls_plugin_deception_timer);
      this.hls_plugin_deception_timer = null;
    }
  }

  setHlsPluginStats(info) {
    this.stats.end = performance.now();
    this.stats.start = this.stats.first = this.stats.end - (Date.now() - info.start_time);
    this.stats.loaded = this.stats.total = info.size;
    this.stats.bwEstimate = (this.stats.total * 8000) / (this.stats.loading.end - this.stats.loading.first);
  }

  getCurrentBuffer() {
    if (!this.hls.media || !this.hls.media.buffered) return 0;
    let time_ranges = [];
    for (let i=0; i < this.hls.media.buffered.length; i++) {
      time_ranges.push({
        start: this.hls.media.buffered.start(i),
        end: this.hls.media.buffered.end(i)
      });
    }
    let curr_pos = this.hls.media.currentTime;
    let curr_range = time_ranges.sort(
      (a, b) => a.start - b.start ? a.start - b.start : b.end - a.end
    ).find(range => curr_pos >= range.start && curr_pos <= range.end);
    return curr_range ? curr_range.end - curr_pos : 0;
  }

  getMaxBuffer() {
    return Math.min(this.player_config.maxBufferLength, this.player_config.maxMaxBufferLength);
  }

  dataURItoArrayBuffer(dataurl) {
    let k = dataurl.indexOf(',');
    let bstr = atob(dataurl.substr(k+1));
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return u8arr.buffer;
  }

  static hasLocalStorage() {
    try {
      window.localStorage.setItem('checkLocalStorage', 'checkLocalStorage');
      window.localStorage.removeItem('checkLocalStorage');
      return true;
    } catch (e) {
      return false;
    }
  }

  static getClientID() {
    let flockplay_id = FlockPlayLoader.hasLocalStorage() ? localStorage.getItem('FlockplayId') : FlockPlayLoader.flockplay_id;
    if (!flockplay_id) {
      flockplay_id = Date.now()+''+Math.floor(Math.random()*1000000000);
      if (FlockPlayLoader.hasLocalStorage()) {
        localStorage.setItem('FlockplayId', flockplay_id);
      } else {
        FlockPlayLoader.flockplay_id = flockplay_id;
      }
    }
    return flockplay_id;
  }

  static checkEnabled(player, options) {
    let flockplay_id = FlockPlayLoader.getClientID();
    let uri = options.check_enabled.url;
    uri += (~uri.indexOf('?') ? '&' : '?') + 'flockplay_id='+flockplay_id;
    if (options.check_enabled.params) {
      for (let key in options.check_enabled.params) {
        uri += `&${key}=${encodeURIComponent(options.check_enabled.params[key])}`;
      }
    }
    videojs.xhr({uri, withCredentials: true, json: true}, (err, resp) => {
      if (!err && resp.statusCode == '200' && resp.body) {
        if (player.flockplay_disabled != !resp.body.enabled) 
        player.flockplay_disabled = !resp.body.enabled;
      }
    });
  }
}

const default_options = {
  http_failback_factor: 0.9,     // сколько ждать peer до срабатывания http, доля от длинны кусочка
  http_failback_fill_factor: 1.5 // сколько ждать peer до срабатывания http, доля от длинны кусочка, в режиме fill bufer 
};

// Регистрируем flockplay в video.js.
registerPlugin('flockplay', function(options) {
  let player = this; // eslint-disable-line no-invalid-this
  if (options.check_enabled) {
    player.flockplay_disabled = true;
    player.flockplay_check_enabled_timer = setInterval(() => {
      FlockPlayLoader.checkEnabled(player, options);
    }, options.check_enabled.period || 60000);
    FlockPlayLoader.checkEnabled(player, options);
  }
  player.on('loadstart', () => {
    let options_ = videojs.mergeOptions(default_options, options);
    if (player.hls_ && !player.hls_.flockplay) FlockPlayLoader.init(player, options_);
  });
  player.on('dispose', () => {
    if (player.hls_ && player.hls_.flockplay) {
      player.hls_.flockplay.destroy();
      if (player.hls_.flockplay.fill_buffer_timer) 
        clearInterval(player.hls_.flockplay.fill_buffer_timer);
    }
    if (player.flockplay_check_enabled_timer) clearInterval(player.flockplay_check_enabled_timer);
  });
});

export default FlockPlayLoader;
